
<script setup>

  import { ref, computed } from 'vue';

  const props = defineProps( {
    
    id: String,

    rows: { type: Number, default: 10 },
    
    maxLength: { type: Number, default: 1000 },
    
    modelValue: String
  
  } );

  const emit = defineEmits( [ 'update:modelValue' ] );

  const data = ref( props.modelValue );

  const count = computed( () => data.value?.length || 0 );

  function onInput( event ) {

    data.value = event.target.value;

    emit( 'update:modelValue', data.value );

  }

</script>

<template>

  <div>

    <input

      v-if="rows < 2" type="text"

      class="block w-full mt-4 border-0 py-1.5 text-neutral-900 shadow-sm ring-1 ring-inset ring-neutral-300
      
        placeholder:text-neutral-400 focus:ring-2 focus:ring-inset focus:ring-lime-800 sm:text-sm sm:leading-6"

      :id="id" :value="data" @input="onInput" :maxLength="maxLength" />

    <textarea

      v-if="rows > 1"

      class="block w-full mt-4 border-0 py-1.5 text-neutral-900 shadow-sm ring-1 ring-inset ring-neutral-300
      
        placeholder:text-neutral-400 focus:ring-2 focus:ring-inset focus:ring-lime-800 sm:text-sm sm:leading-6"

      :id="id" :value="data" @input="onInput" :maxLength="maxLength" :rows="rows" />

    <slot :count="count" :maxLength="maxLength" />

  </div>

</template>
